import { css, SerializedStyles } from '@emotion/react'
import { rwdrc2 } from '~/configs/rwdrc'

export const createDesktopCss = (rootCss: SerializedStyles) =>
  css`
    @media screen and (min-width: ${rwdrc2.desktop.min + 'px'}) {
      ${rootCss}
    }
  `
